import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { catalogLinksMessages as m } from './catalogLinksMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './CatalogLinks.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CatalogLinksTimelineProps {
  /** The release day as the song bar shows it. */
  day: string;
  hasPresave: boolean;
}

/** Now → release day (design c1): what the block shows before and from the release day. */
const CatalogLinksTimelineComponent: React.FC<CatalogLinksTimelineProps> = ({ day, hasPresave }) => {
  const intl = useIntl();
  return (
    <div className={styles.timeline}>
      <div className={styles.step}>
        <span className={styles.stepDot} />
        <span className={styles.stepWhen}>{intl.formatMessage(m.now)}</span>
        <span className={styles.stepWhat}>{intl.formatMessage(hasPresave ? m.nowPresave : m.nowCountdown)}</span>
      </div>
      <div className={styles.step}>
        <span className={styles.stepDot} />
        <span className={styles.stepWhen}>{day}</span>
        <span className={styles.stepWhat}>{intl.formatMessage(m.dayPlay)}</span>
      </div>
    </div>
  );
};

export const CatalogLinksTimeline = TypedMemo(CatalogLinksTimelineComponent);
